"use strict";

angular.module("vendor")
.directive("partnershipModelManagement", function() {
    return {
        bindToController: {
            industryFilter: "<?",
            statusFilter: "<?",
            statusFilterParameter: "<?",
            statusFilterService: "<",
            salesRepStatusFilter: "<?",
            salesRepStatusFilterParameter: "<?",
            salesRepStatusFilterService: "<?",
            financialStatusFilter: "<?",
            financialStatusFilterParameter: "<?",
            financialStatusFilterService: "<?",
            dateFilter: "<?",
            tagFilter: "<?",
            tagFilterParameter: "<?",
            tagFilterService: "<",
            zoneFilter: "<?"
        },
        restrict: "E",
        transclude: {
            "partnershipModelManagementSidebar": "?partnershipModelManagementSidebar",
            "partnershipModelManagementHeader": "?partnershipModelManagementHeader",
            "partnershipModelManagementTable": "partnershipModelManagementTable"
        },
        templateUrl: require("./partnership-model-management.directive.html"),
        controller: PartnershipModelManagementController,
        controllerAs: "partnershipModelManagementCtrl"
    };
});

function PartnershipModelManagementController($scope, $state, StateExtensionService) {
    $scope.hasFilter = this.industryFilter || this.statusFilter || this.tagFilter || this.zoneFilter;
    $scope.sharedScope = $scope.$new();
    $scope.sharedScope.$on("industryFilterUpdated", function(event, industriesFilter) {
        angular.extend($scope.params, industriesFilter);
        $scope.$emit("clearSelection");
    });

    $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
    $scope.salesRepStatusHelpTip = $scope.service.getSalesRepStatusHtmlContent();
    $scope.financialStatusHelpTip = $scope.service.getFinancialStatusHtmlContent();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
        $scope.salesRepStatusHelpTip = $scope.service.getSalesRepStatusHtmlContent();
        $scope.financialStatusHelpTip = $scope.service.getFinancialStatusHtmlContent();
    });

    $scope.$on("statusDateFilterUpdated", function(event, statusFilter) {
        StateExtensionService.updateUrlParams(statusFilter);
        angular.extend($scope.params, statusFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("salesRepStatusFilterUpdated", function(event, statusFilter) {
        StateExtensionService.updateUrlParams(statusFilter);
        angular.extend($scope.params, statusFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("financialStatusFilterUpdated", function(event, selectedStatus) {
        StateExtensionService.updateUrlParams({financial_status: selectedStatus});
        $scope.params.financial_status = selectedStatus;
        $scope.$emit("clearSelection");
    });

    $scope.$on("dateFilterUpdated", function(event, dateFilter) {
        StateExtensionService.updateUrlParams(dateFilter);
        angular.extend($scope.params, dateFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("tagFilterUpdated", function(event, tagsFilter) {
        StateExtensionService.updateUrlParams(tagsFilter);
        angular.extend($scope.params, tagsFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("zoneFilterUpdated", function(event, zonesFilter) {
        StateExtensionService.updateUrlParams(zonesFilter);
        angular.extend($scope.params, zonesFilter);
        $scope.$emit("clearSelection");
    });

    $scope.editPartnership = function(partnership) {
        $state.go("customer", {id: partnership.id});
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/partnership-model-management.directive.js
// module id = 832
// module chunks = 0